/**
 * Set up routing for all CertificateTemplate views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import AuthoringLayout from '../admin/components/AuthoringLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import certificate-template views
import AdminCertificateTemplateList from './views/AdminCertificateTemplateList.js.jsx';
import AdminCreateCertificateTemplate from './views/AdminCreateCertificateTemplate.js.jsx';
import AdminSingleCertificateTemplate from './views/AdminSingleCertificateTemplate.js.jsx';
import AdminUpdateCertificateTemplate from './views/AdminUpdateCertificateTemplate.js.jsx';

class CertificateTemplateAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleCertTempUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All certificate-templates', path:null}]}
          exact
          component={AdminCertificateTemplateList}
          role="admin"
          path="/admin/certificate-templates"
        />
        <YTRoute
          breadcrumbs={[{display:'All certificate-templates', path:'/admin/certificate-templates'},{display:'New',path:null}]}
          exact
          component={AdminCreateCertificateTemplate}
          role="admin"
          path="/admin/certificate-templates/new"
        />        
        <YTRoute
          breadcrumbs={[{display:'All certificate-templates', path:'/admin/certificate-templates'},{display:'Details',path:null}]}
          exact
          component={AdminSingleCertificateTemplate}
          role="admin"
          path="/admin/certificate-templates/:certificateTemplateId"
        />
        <YTRoute
          breadcrumbs={[{display:'All certificate-templates', path:'/admin/certificate-templates'},{display:'Details',path:singleCertTempUpdatePath},{display:'Update',path:null}]}
          exact
          component={AdminUpdateCertificateTemplate}
          role="admin"
          path="/admin/certificate-templates/:certificateTemplateId/update"
        />
      </Switch>
    )
  }
}

export default withRouter(CertificateTemplateAdminRouter);



// WEBPACK FOOTER //
// modules/certificateTemplate/CertificateTemplateAdminRouter.js.jsx